import React from 'react';
import listOfCities from './listofcities.txt';
import listOfCountries from './listofcountries.txt';
import listOfEverything from './countries.txt';
import Modal from './Modal.js';
import './index.css';
//TODO: (fix) extra long names messes with heights.
//TODO: (fix) we're gonna need to get country codes for the capitals, since small country capitals are being stolen by bigger countries lol.
class App extends React.Component {
  constructor(props){
    super(props);

    this.state={
      citiesOne:null,
      citiesTwo:null,
      weatherCondOne:null,
      weatherCondTwo:null,
      weatherHiddenCondOne:null,
      weatherHiddenCondTwo:null,
      step: 0,
      gameState: -1,
      buttonPrompt: "Start?",
      readyOne: false,
      readyTwo: false,
      quickstart:false,
      score: this.getCookie({type: "score"}),
      highscore: this.getCookie({type: "highscore"}),
      streak: this.getCookie({type: "streak"}),
      posOne: 0,
      posTwo: 0,
      showModal: (this.getCookie({type: "score"}) === 0 ? true : false)
    }
    this.clickCity = this.clickCity.bind(this);

    fetch(listOfEverything)
    .then(out => out.json())
    .then(text =>{
      //const citiesArr = text.split(',');
      //console.log("TOTAL LEN: " + text.length);
      this.state.posOne = Math.round(Math.random() * text.length - 1);
      this.getLongLat(text[this.state.posOne], 2);

      this.state.posTwo = Math.round(Math.random() * text.length - 1);

      if(this.state.posOne === this.state.posTwo){
        this.state.posTwo = (this.state.posOne + 1) % (text.length - 1)
      }

      this.getLongLat(text[this.state.posTwo], 1);

      //console.log("ARR: " + text[0] + " 1: " + this.state.posOne + " 2: " + this.state.posTwo);
    });
  }

  getCookie(props){
    let name = props.type + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return 0;
  }

  setCookie(props){
    const d = new Date();
    d.setTime(d.getTime() + (31 * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    //console.log("SET COOKIE: " + props.type + "=" + props.value + ";" + expires + ";path=/");
    document.cookie = props.type + "=" + props.value + ";" + expires + ";path=/";
  }

  clickCity(props) {
    if (this.state.step != 0){
      let correct = -1;
      let isCorrect = false
      //console.log("???1: " + (this.state.weatherCondOne.main.temp > this.state.weatherCondTwo.main.temp && props.index === 1) + " : " + props.index);
      //console.log("???1/2: " + (this.state.weatherCondOne.main.temp < this.state.weatherCondTwo.main.temp && props.index === 2) + " : " + props.index);
      //console.log("???2: " + this.state.weatherCondOne.main.temp + " > " + this.state.weatherCondTwo.main.temp + " : " + props.index);
      if((this.state.weatherCondOne.main.temp > this.state.weatherCondTwo.main.temp && props.index === 1) ||
        (this.state.weatherCondOne.main.temp < this.state.weatherCondTwo.main.temp && props.index === 2)){
        correct = props.index;
        isCorrect = true;
        //console.log("???: CORRRRRECT");
      }else{
        if(props.index === 1){
          correct = 2;
        }else{
          correct = 1;
        }
      }
      /*if (this.state.weatherCond[props.index].main.temp > this.state.weatherCond[props.index === 0 ? 1 : 0].main.temp ) {
        //console.log("CORRECT! (" + props.index + ")");
        //console.log("CORRECT! (" + this.state.weatherCond[props.index].main.temp > this.state.weatherCond[props.index === 0 ? 1 : 0].main.temp  + ")");
        correct = props.index;
        isCorrect = true;
      }*/

      if (isCorrect){
        this.state.streak++
      }else{
        this.state.streak = 0;
      }

      this.setCookie({type:"streak", value:this.state.streak});

      let toAdd = Math.round(this.state.streak / (this.state.step));
      if (toAdd < 1){
        toAdd = 1;
      }
      this.state.score = (+this.state.score) + (+toAdd);

      if(this.state.score > this.state.highscore){
        this.state.highscore = this.state.score;
        this.setCookie({type:"highscore", value:this.state.highscore});
      }

      if(this.state.streak === 0){
        this.state.score = 0;
      }
      this.setCookie({type:"score", value:this.state.score});
      //console.log("AGAIN STATEMENT");
      this.setState({
        gameState: correct,
        buttonPrompt: "Again?"
      });
    }
  }

  getHint(){
    let tempWeatherCondOne = {...this.state.weatherHiddenCondOne};
    let tempWeatherCondTwo = {...this.state.weatherHiddenCondTwo};
    this.state.step++;
    if (this.state.buttonPrompt === "Again?"){
      //console.log("AGAIN!");

      //need to tell if correct
      this.setState({
        citiesOne:null,
        citiesTwo:null,
        weatherCondOne:null,
        weatherCondTwo:null,
        weatherHiddenCond:null,
        weatherHiddenCond:null,
        step: 0,
        gameState: -1,
        buttonPrompt: "Start?",
        readyOne: false,
        readyTwo: false,
        quickstart:true,
        score: this.state.score,
        highscore: this.state.highscore,
        streak: this.state.streak,
        posOne: 0,
        posTwo: 0
      });

      fetch(listOfEverything)
      .then(out => out.json())
      .then(text =>{
        //const citiesArr = text.split(',');
        //console.log("TOTAL LEN: " + text.length);
        this.state.posOne = Math.round(Math.random() * text.length - 1);
        this.getLongLat(text[this.state.posOne], 0);
        
        this.state.posTwo = Math.round(Math.random() * text.length - 1);
  
        if(this.state.posOne === this.state.posTwo){
          this.state.posTwo = (this.state.posOne + 1) % (text.length - 1)
        }
  
        this.getLongLat(text[this.state.posTwo], 1);
        
        //console.log("ARR: " + text[0] + " 1: " + this.state.posOne + " 2: " + this.state.posTwo);
      });
    }else{
      switch(this.state.step) {
        case 1:
          this.state.buttonPrompt = "Hint?";
          tempWeatherCondTwo.name= this.state.weatherCondTwo.name;
          tempWeatherCondOne.name = this.state.weatherCondOne.name;
          break;
        case 2:
          tempWeatherCondTwo.country = this.state.weatherCondTwo.country;
          tempWeatherCondOne.country = this.state.weatherCondOne.country;
          break;
        case 3:
          //console.log("AAASSDDAS");
          this.state.buttonPrompt = "Good luck!";
          tempWeatherCondTwo.weather[0].description = this.state.weatherCondTwo.weather[0].description;
          tempWeatherCondOne.weather[0].description = this.state.weatherCondOne.weather[0].description;
          break;
      }
  
      this.setState({
        weatherHiddenCondOne: tempWeatherCondOne,
        weatherHiddenCondTwo: tempWeatherCondTwo,
        step: this.state.step,
        prompt: this.state.prompt
      });
    }
  }

  CityBlock(props) {
    //console.log("CITYBLOCK: " + JSON.stringify(props));
    //<button onClick={() => this.clickCity()} className="CityBlock">
    const placeholder = "????";
    if(props.correct != null){
      return (
        <button onClick={props.onClick} className={props.correct ? "CityBlockRight" : "CityBlockWrong"}>
          {props.value.name}<br/>
          {props.value.country}<br/>
          {"\"" + props.value.weather[0].description + "\""}<br/>
          <h2>{(props.value.main.temp - 273.15).toFixed(2)+"c"}</h2>
        </button>
      );
    }
    //<p className="TinyText">Is the capital of</p>
    return (
      <button onClick={props.onClick} className="CityBlock">
        {props.value.name ? props.value.name : placeholder}<br/>
        {props.value.country ? props.value.country : placeholder}<br/>
        {props.value.weather[0].description  ? "\"" + props.value.weather[0].description + "\"" : placeholder}<br/>
        <h2>{props.value.main.temp ? (props.value.main.temp - 273.15).toFixed(2)+"c" : placeholder}</h2>
      </button>
    );
  }

  async getWeather(city, id){
    //console.log("START WEATHER GET FOR CITY: " + city[0].name);
    const resp = await fetch('https://api.openweathermap.org/data/2.5/weather?lat=' + city[0].lat + '&lon=' + city[0].lon + '&appid=03974cfec47cfdf81b680c174f5c690d')
    .then(response => response.json())
    .then(data => {
      //start new bit, replacing the getfullcities
      //console.log("TEST 2 " + JSON.stringify(city));
      //console.log("TEST 2.5 " + city.country);
      data.country = city.country;
      //console.log("TEST 2.75 " + data.country);

      let tempWeatherCond = JSON.parse(JSON.stringify(data));
      tempWeatherCond.name = "";
      tempWeatherCond.country = "";
      tempWeatherCond.weather[0].description = "";
      tempWeatherCond.main.temp = "";

      //console.log("COMPARE? " + JSON.stringify(data));
      //console.log("COMPARE1? " + JSON.stringify(this.state.weatherCond));
      //console.log("COMPARE2? " + JSON.stringify(this.state.weatherHiddenCond));
      if (id === 1){
        this.setState({
          //weatherCond: this.state.weatherCond.concat(data),
          weatherCondOne: data,
          //weatherHiddenCond: this.state.weatherHiddenCond.concat(tempWeatherCond),
          weatherHiddenCondOne: tempWeatherCond,
          readyOne: true
        });
      }else{
        this.setState({
          //weatherCond: this.state.weatherCond.concat(data),
          weatherCondTwo: data,
          //weatherHiddenCond: this.state.weatherHiddenCond.concat(tempWeatherCond),
          weatherHiddenCondTwo: tempWeatherCond,
          readyTwo: true 
        });
      }
      
      //console.log("COMPARE2? " + JSON.stringify(tempWeatherCond));
      //end new bit, replacing the getfullcities
      //this.getCountriesFullNames(data);
    })
    .catch(error => console.log("ERR: " + error));
  }

  async getLongLat(city, id){
    //console.log("BEEG START CITY: " + city.name.common + " | " + city.cca2 + " | " + city.capital[0]);
    const resp = await fetch('https://api.openweathermap.org/geo/1.0/direct?q=' + city.capital[0] + "," + city.cca2 + '&appid=03974cfec47cfdf81b680c174f5c690d') 
    .then(response => response.json())
    .then(data => {
      if (data[0].lon){
        //console.log("TEST 1 " + city.name.common);
        if (id === 1){
          this.setState({
            citiesOne: data
          });
        }else{
          this.setState({
            citiesTwo: data
          });
        }
      }
      //console.log("LOC DATA: " + JSON.stringify(data));
      data.country = city.name.common;
      //console.log("TEST 1.5 " + data.country + " - " + city.name.common);
      this.getWeather(data, id);

      //console.log("CITY GENERIC LON: " + data[0].lon + " | LAT: " + data[0].lat);  
      
      return data; 
    })
    .catch(error => console.log("ERR: " + error));
  }


  render() {
    //console.log("Time: " + Date().toLocaleString());
    
    //console.log("RENDER LEN: " + this.state.cities.length);  
    //console.log("this.state.ready check: " + this.state.ready[0] + " : " + this.state.ready[1]); 
    //if (this.state.weatherCond[0] && this.state.weatherCond[1]) {
    if (this.state.readyOne && this.state.readyTwo) {
      //i am aware that this is yucky, but cbf thinking of a smarter solution
      if(this.state.quickstart === true && this.state.buttonPrompt === "Start?"){
        this.setState({
          buttonPrompt: "Hint?",
        });
        this.getHint()
      }
      //console.log("CITY GENERIC(2) LON: " + this.state.citiesTwo.lon + " | LAT: " + this.state.citiesOne.lat); 
      
      if(this.state.gameState === 2){
        return <div>      
          <div id="overlayScore">{"HIGHSCORE: " + this.state.highscore}<br/>{"SCORE: " + this.state.score}</div>  
          <div id="overlayStreak">{"STREAK: " + this.state.streak}</div> 
        <div>          
          <this.CityBlock value={this.state.weatherCondTwo}correct={true}/>
          <this.CityBlock value={this.state.weatherCondOne} correct={false}/> 
        </div>        
        <div id="overlayButton">
          <button onClick={() => this.getHint()} className="HintButton">{this.state.buttonPrompt}</button>
        </div>    
        <div id="overlayHelpButton">
          <button className="HelpButton" onClick={() => this.setState({showModal: !this.state.showModal})}>{"?"}</button>
        </div>    
        <Modal open={this.state.showModal} onClose={() => this.setState({showModal: !this.state.showModal})}></Modal>  
      </div>;
      }else if (this.state.gameState === 1){
        return <div>      
          <div id="overlayScore">{"HIGHSCORE: " + this.state.highscore}<br/>{"SCORE: " + this.state.score}</div> 
          <div id="overlayStreak">{"STREAK: " + this.state.streak}</div> 
        <div>          
          <this.CityBlock value={this.state.weatherCondTwo}correct={false}/>
          <this.CityBlock value={this.state.weatherCondOne} correct={true}/> 
        </div>        
        <div id="overlayButton">
          <button onClick={() => this.getHint()} className="HintButton">{this.state.buttonPrompt}</button>
        </div>    
        <div id="overlayHelpButton">
          <button className="HelpButton" onClick={() => this.setState({showModal: !this.state.showModal})}>{"?"}</button>
        </div>    
        <Modal open={this.state.showModal} onClose={() => this.setState({showModal: !this.state.showModal})}></Modal> 
      </div>;
      }else{
        return <div>  
          <div id="overlayScore">{"HIGHSCORE: " + this.state.highscore}<br/>{"SCORE: " + this.state.score}</div>   
          <div id="overlayStreak">{"STREAK: " + this.state.streak}</div>   
        <div>          
          <this.CityBlock value={this.state.weatherHiddenCondTwo}onClick = {() => this.clickCity({index: 2})}/>
          <this.CityBlock value={this.state.weatherHiddenCondOne} onClick = {() => this.clickCity({index: 1})}/> 
        </div>        
        <div id="overlayButton">
          <button onClick={() => this.getHint()} className="HintButton">{this.state.buttonPrompt}</button>
        </div>    
        <div id="overlayHelpButton">
          <button className="HelpButton" onClick={() => this.setState({showModal: !this.state.showModal})}>{"?"}</button>
        </div>    
        <Modal open={this.state.showModal} onClose={() => this.setState({showModal: !this.state.showModal})}></Modal>
      </div>;
      }
    }

    const placeholder = "????";
    return <div>   
      <div id="overlayScore">{"HIGHSCORE: " + this.state.highscore}<br/>{"SCORE: " + this.state.score}</div> 
      <div id="overlayStreak">{"STREAK: " + this.state.streak}</div> 
      <div>    
        <button className="CityBlock">{placeholder}<br/>{placeholder}<br/>{placeholder}<br/><h2>{placeholder}</h2></button>   
        <button className="CityBlock">{placeholder}<br/>{placeholder}<br/>{placeholder}<br/><h2>{placeholder}</h2></button>  
      </div>    
      <div id="overlayButton">
        <button className="HintButton">{this.state.buttonPrompt}</button>
      </div>   
      <div id="overlayHelpButton">
        <button className="HelpButton" onClick={() => this.setState({showModal: !this.state.showModal})}>{"?"}</button>
      </div>    
      <Modal open={this.state.showModal} onClose={() => this.setState({showModal: !this.state.showModal})}></Modal> 
    </div>;
  }
}

export default App;
    